import { render, staticRenderFns } from "./GetReport.vue?vue&type=template&id=554896fa&"
import script from "./GetReport.vue?vue&type=script&lang=js&"
export * from "./GetReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports